import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-car-line',
    title: 'Finding the Right Vehicle',
    body: "Not sure what you're looking for? Tell us your budget, lifestyle, and must-haves — we'll do the legwork. As licensed auto brokers, we have access to inventory far beyond what's on our lot, including off-market vehicles, dealer trades, and auction-sourced cars that never hit the public market.",
    link: '/inventory',
    linkLabel: 'Browse Inventory',
  },
  {
    icon: 'ri-bank-line',
    title: 'Financing & Pre-Approval',
    body: "Whether you have excellent credit, challenged credit, or no credit history at all, we work with multiple lenders to find you a real rate — not a dealer-inflated one. Ask us about pre-approval, monthly payment estimates, or how to improve your financing position before you buy.",
    link: '/financing',
    linkLabel: 'Explore Financing',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Trade-In Valuations',
    body: "Wondering what your current vehicle is worth? We provide honest, market-based trade-in estimates — no lowball tactics, no bait-and-switch. Send us your year, make, model, mileage, and condition and we'll give you a straight answer, usually within a few hours.",
    link: '/trade-in',
    linkLabel: 'Get a Trade Estimate',
  },
  {
    icon: 'ri-truck-line',
    title: 'Remote Buying & Delivery',
    body: "You don't have to be in Warrenton to buy from us. We handle the entire purchase process remotely — digital paperwork, video walkthroughs, and vehicle delivery across Oregon and Washington. Many of our customers have never set foot in our showroom and are completely happy with the experience.",
    link: '/how-it-works',
    linkLabel: 'How Remote Buying Works',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Broker Search Service',
    body: "Can't find what you want on our lot? Our broker service lets us search the entire Pacific Northwest market on your behalf. You tell us exactly what you want — year range, trim level, color, features — and we hunt it down. No settling for 'close enough.'",
    link: '/broker-services',
    linkLabel: 'Learn About Brokering',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Price & Deal Questions',
    body: "Seen a vehicle elsewhere and want a second opinion on whether it's a fair deal? Ask us. We'll give you an honest assessment of the market value, common issues to watch for on that model, and whether the asking price makes sense. No strings attached — we'd rather you make a great decision than a rushed one.",
    link: '/compare',
    linkLabel: 'See How We Compare',
  },
];

export default function ContactHelpWith() {
  const helpTopics = [
    {
      icon: 'ri-car-line',
      title: 'Vehicle Questions',
      description: 'Is that Subaru still available? Does it have heated seats? Will it fit my kayak? Ask away.',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Test Drives',
      description: 'Schedule a test drive at our lot or we\'ll bring it to you. Your driveway, your rules.',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Financing Help',
      description: 'Pre-approval questions, rate shopping, or just "will I actually get approved?" — we\'ll walk you through it.',
    },
    {
      icon: 'ri-exchange-line',
      title: 'Trade-Ins',
      description: 'Wondering what your current ride is worth? Send us some pics and we\'ll give you a real number, not a lowball.',
    },
    {
      icon: 'ri-search-line',
      title: 'Broker Services',
      description: 'Don\'t see what you want? Tell us your dream car and we\'ll hunt it down through our dealer network.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Puplandia Partnership',
      description: 'Questions about our Oregon Dog Rescue donations? We love talking about the pups we help.',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              What Can We Help With?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Whether you're ready to buy or just kicking tires (digitally), we're here to help. No question is too basic, and we promise not to put you on a mailing list.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s) => (
              <article
                key={s.title}
                className="bg-[#F7F5F0] border border-[#E8E2D6] rounded-xl p-6 flex flex-col gap-3 hover:border-[#E8B84B] transition-colors group"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-white border border-[#E8E2D6] rounded-lg group-hover:border-[#E8B84B] group-hover:bg-[#FFFBF0] transition-all">
                  <i className={`${s.icon} text-[#E8B84B] text-xl`}></i>
                </div>
                <h3
                  className="text-base font-black text-[#1A2332] leading-snug"
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-[#5A6A7A] leading-relaxed flex-1">{s.body}</p>
                <Link
                  to={s.link}
                  className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-[#1A2332] hover:text-[#E8B84B] transition-colors mt-1 whitespace-nowrap cursor-pointer"
                >
                  {s.linkLabel}
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
